"use strict";

import { LinearProgressIndicator } from '@autoguru/overdrive';
import { jsx as _jsx } from "react/jsx-runtime";
export const PageLoading = /*#__PURE__*/_jsx("div", {
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%'
  },
  children: /*#__PURE__*/_jsx(LinearProgressIndicator, {})
});